import controllers from "venuescanner-js/services/controllers";

export const getOngoingThreads = async () => {
  const response = await controllers.weeklySummary.getOngoingThreads.get();
  const {
    data: { ongoingThreads },
  } = response;

  return ongoingThreads;
};

export const getFlags = async () => {
  const response = await controllers.weeklySummary.getFlags.get();
  const { data } = response;

  return data.flags;
};

export const setFlags = async (flags) => {
  return await controllers.weeklySummary.setFlags.post(flags);
};

export const getHasSubscriptionToAllVenues = async () => {
  const response = await controllers.user.hasSubscriptionToAllVenues.get();
  const {
    data: { hasSubscriptionToAllVenues },
  } = response;

  return hasSubscriptionToAllVenues;
};
